'use client';

import { Toaster as ToasterList } from 'sonner';

import { useAppSelector } from '@shared/hooks/redux';

import cls from './Toaster.module.scss';

export const Toaster = () => {
  const width = useAppSelector((state) => state.screenSizeTracking.width);
  const offset = (width - 1360) / 2 < 40 ? 32 : (width - 1360) / 2;

  return (
    <div className={cls.toaster}>
      <ToasterList
        position={'top-right'}
        offset={{ top: '130px', right: `${offset}px` }}
        toastOptions={{
          className: `${cls.list}`
        }}
      />
    </div>
  );
};
